"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingFactor = exports.BillingTypes = exports.BillingType = void 0;
const payment_period_1 = require("./payment-period");
var BillingType;
(function (BillingType) {
    BillingType["DirectBill"] = "Direct Bill";
    BillingType["PreAuthorizedClearance"] = "PAC";
})(BillingType = exports.BillingType || (exports.BillingType = {}));
exports.BillingTypes = Object.values(BillingType);
function getBillingFactor({ paymentPeriod, billingType }) {
    const BASE_PAYMENT_FACTOR = 1;
    const INCREASED_PAYMENT_FACTOR = 1.05;
    if (paymentPeriod === payment_period_1.PaymentPeriod.Annually) {
        return BASE_PAYMENT_FACTOR;
    }
    if (billingType === BillingType.PreAuthorizedClearance) {
        return BASE_PAYMENT_FACTOR;
    }
    return INCREASED_PAYMENT_FACTOR;
}
exports.getBillingFactor = getBillingFactor;
//# sourceMappingURL=billing-type.js.map